<template>
  <ValidationProvider
    :class="['form__control', className]"
    :vid="vid"
    :rules="rules"
    :name="name"
    :mode="validationMode"
    :custom-messages="customMessages"
    tag="div"
    ref="provider"
    v-slot="{ errors, validated, invalid }"
  >
    <label :for="vid">
      <span :class="['label', labelClass]">
        {{ label }}
      </span>
    </label>

    <v-textarea
      rows="4"
      :id="vid"
      :placeholder="placeholder"
      :error-messages="errors[0] || externalErrorMsg"
      :append-icon="displayValidationIcon(errors, externalErrorMsg, validated)"
      :hide-details="hideDetails"
      :class="[
        'input__control',
        { uppercase: isUppercase, 'field-invalid': invalid },
      ]"
      v-model="innerValue"
      outlined
      ref="input"
      @blur="handleBlur"
      :no-resize="noResize"
      :aria-label="ariaLabel"
    >
      <template v-slot:message="{ message }">
        <span v-html="message"></span>
      </template>
    </v-textarea>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "BaseTextarea",
  components: {
    ValidationProvider,
  },
  props: {
    vid: String,
    value: String,
    className: String,
    name: String,
    fieldName: String,
    label: String,
    labelClass: String,
    externalErrorMsg: String,
    customMessages: Object,
    placeholder: String,
    hideDetails: { type: [Boolean, String] },
    isUppercase: Boolean,
    autocomplete: String,
    mask: String,
    tooltip: Object,
    rules: [Object, String],
    validationMode: {
      default: "eager",
      required: false,
    },
    hideValidationIcon: Boolean,
    noResize: {
      type: Boolean,
      default: false,
    },
    ariaLabel: String,
  },
  data: () => ({
    innerValue: "",
    tooltipMinWidth: 280,
  }),
  watch: {
    // Handles internal model changes.
    innerValue(value) {
      this.$emit("input", value, this.fieldName, this.$refs.provider);
    },
    // Handles external model changes.
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val;
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  mounted() {
    // trigger validate
    if (this.innerValue) {
      this.$refs.input.updateValue();
      this.$refs.provider.validate();
    }

    // fix issue: tooltip width is not stable
    this.$nextTick(() => {
      this.tooltipMinWidth = this.$refs.input?.$el?.clientWidth;
    });
  },
  methods: {
    handleBlur(e) {
      this.$emit("blur", e.target.value, this.fieldName, this.$refs.provider);
    },
    displayValidationIcon(errors, externalErrorMsg, validated) {
      if (this.hideValidationIcon) {
        return "";
      }
      return errors[0] || externalErrorMsg ? "" : validated ? "icon-check" : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: ($grid-breakpoints-xs)) {
  .tooltip__wrap {
    float: right;
    margin-top: 2px;
  }
}

@media screen and (max-width: ($grid-breakpoints-xs - 1)) {
  .tooltip__wrap {
    display: block;
  }
}

:deep(.v-text-field.v-text-field--enclosed) {
  .v-text-field__details {
    padding-left: 0;
    padding-right: 0;
    overflow: visible;
  }
}

:deep(.v-text-field__details .v-messages__message) {
  line-height: normal;
}

:deep(.v-textarea) {
  margin-top: 5px;
}

:deep(.v-text-field__slot) {
  padding: 2px 2px;
  textarea {
    margin-top: 0px !important;
  }
}
</style>
